import React from "react";
import { Character } from "../common/character";
import { InputFieldAndLabel } from "../common/inputFieldAndLabel";
import { Department } from "../helpers/department";
import D20IconButton from "../solo/component/d20IconButton";
import { localizedFocus } from "./focusHelper";
import { FocusRandomTable, FocusRandomTableWithHints } from "../solo/table/focusRandomTable";
import { useTranslation } from "react-i18next";

interface IFocusSelectionProperties {
    character: Character;
    addFocus: (string) => void;
    value: string;
    randomFocusDepartment?: Department;
    suggestions?: string;
    hints?: string[];
    label?: string;
}

export const FocusSelectionView: React.FC<IFocusSelectionProperties> = ({character, addFocus, randomFocusDepartment, suggestions, hints, label, value}) => {

    const { t } = useTranslation();

    const selectRandomFocus = () => {
        let done = false;
        while (!done) {
            let focus = hints != null
                ? localizedFocus(FocusRandomTableWithHints(randomFocusDepartment, hints))
                : localizedFocus(FocusRandomTable(randomFocusDepartment));
            if (character.focuses.indexOf(focus) < 0) {
                done = true;
                addFocus(focus);
            }
        }
    }

    if (label == null) {
        label = t('Construct.other.focus');
    }

    if (suggestions == null && hints?.length) {
        suggestions = hints.join(", ");
    }

    return (<>
        <div className="d-flex justify-content-between align-items-center flex-wrap">
            <InputFieldAndLabel id="focus" labelName={label}
                value={value || ""} className="mt-1"
                onChange={(v) => addFocus(v?.length ? v : undefined)} />
            <div style={{ flexShrink: 0 }} className="mt-1">
                <D20IconButton onClick={() => selectRandomFocus()}/>
            </div>
        </div>
        {suggestions
            ? (<div className="py-1 text-white"><b>{t('Common.text.suggestions')}:</b> {suggestions}</div>)
            : undefined}
    </>);
}